document.addEventListener('click', function(event){
  const button=event.target.closest('[data-qty-minus],[data-qty-plus]');
  if(!button)return;
  const input=button.parentElement.querySelector('input[name="quantity"]');
  const current=parseInt(input.value,10)||1;
  input.value=button.hasAttribute('data-qty-plus')?current+1:Math.max(1,current-1);
});


(function(){
  function getNextTuesday7(){
    const now = new Date();
    const target = new Date(now);
    target.setHours(19,0,0,0);
    const day = now.getDay();
    let delta = (2 - day + 7) % 7;
    if(delta === 0 && now >= target) delta = 7;
    target.setDate(now.getDate() + delta);
    return target;
  }
  function updateVaultCountdown(){
    document.querySelectorAll('[data-vault-countdown]').forEach(function(el){
      const now = new Date();
      let target, label;
      const day = now.getDay();
      const isTuesday = day === 2;
      const start = new Date(now); start.setHours(19,0,0,0);
      const end = new Date(now); end.setHours(21,0,0,0);
      if(isTuesday && now >= start && now < end){
        el.classList.add('is-live');
        label = 'LIVE NOW · 7–9 PM CENTRAL';
        target = end;
      } else {
        el.classList.remove('is-live');
        target = getNextTuesday7();
        label = 'NEXT LIVE · TUESDAY · 7 PM CENTRAL';
      }
      const labelNode = el.querySelector('.vault-countdown-label');
      if(labelNode) labelNode.textContent = label;
      let diff = Math.max(0, target.getTime() - now.getTime());
      const dayMs=86400000, hour=3600000, minute=60000, second=1000;
      const days=Math.floor(diff/dayMs); diff%=dayMs;
      const hours=Math.floor(diff/hour); diff%=hour;
      const minutes=Math.floor(diff/minute); diff%=minute;
      const seconds=Math.floor(diff/second);
      const set=(name,value)=>{const node=el.querySelector('[data-'+name+']');if(node)node.textContent=String(value).padStart(2,'0');};
      set('days',days); set('hours',hours); set('minutes',minutes); set('seconds',seconds);
    });
  }
  updateVaultCountdown();
  setInterval(updateVaultCountdown,1000);
})();


/* Lucky Dragon: place Minnit chat beside the Streamio Live Commerce player. */
(function(){
  function setupLiveChat(){
    if(!location.pathname.includes('/apps/livecom/livecommerce')) return;
    var chat=document.querySelector('.ld-live-commerce-live-area .ld-live-chat');
    if(!chat || chat.dataset.positioned==='true') return;
    var selectors=[
      '[class*="streamio"]','[id*="streamio"]','[data-app-block*="streamio"]',
      'iframe[src*="streamio"]','iframe[src*="livecom"]'
    ];
    var target=null;
    for(var i=0;i<selectors.length && !target;i++){
      var nodes=document.querySelectorAll(selectors[i]);
      for(var j=0;j<nodes.length;j++){
        var n=nodes[j];
        if(n!==chat && !chat.contains(n) && n.getBoundingClientRect().width>250){ target=n; break; }
      }
    }
    if(!target) return;
    var container=target.closest('section, [class*="app"], [id*="app"], .shopify-app-block') || target.parentElement;
    if(!container || container===document.body || container===document.documentElement) container=target.parentElement;
    if(!container) return;
    var row=document.createElement('div');
    row.className='ld-streamio-chat-row';
    container.parentNode.insertBefore(row,container);
    row.appendChild(container);
    row.appendChild(chat);
    chat.dataset.positioned='true';
    var fallback=document.querySelector('[data-streamio-fallback]');
    if(fallback) fallback.style.display='none';
  }
  var tries=0;
  function retry(){ setupLiveChat(); if(tries++<20) setTimeout(retry,500); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',retry); else retry();
  new MutationObserver(function(){setupLiveChat();}).observe(document.documentElement,{childList:true,subtree:true});
})();
